//helpers for language arabic styles in scripts
export function getTooltipDirection() {
	const language = localStorage.getItem('language')
	let tooltipDirection = ''

	if (language === 'ar') {
		tooltipDirection = 'left'
	} else {
		tooltipDirection = 'right'
	}

	return tooltipDirection
}

export function getCurrentLanguage() {
	const language = localStorage.getItem('language')
	let currentLanguage = null

	if (language) {
		currentLanguage = language
	}

	return currentLanguage
}

export function getLanguageArabic() {
	const language = localStorage.getItem('language')
	let isArabic = null

	if (language === 'ar') {
		isArabic = true
	} else {
		isArabic = false
	}

	return isArabic
}

export function getLanguagePortuguese() {
	const language = localStorage.getItem('language')
	let isPortuguese = null

	if (language === 'pt') {
		isPortuguese = true
	} else {
		isPortuguese = false
	}

	return isPortuguese
}

export function getEntity() {
	const entity = localStorage.getItem('userEntity')
	let isEntity = null

	if (entity) {
		isEntity = entity
	}

	return isEntity
}
